import { useParams } from 'react-router'
import { Heading } from '@/components/base/heading'
// @ts-expect-error fragment is used in the query by fragment name
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ItemType, ItemTypeFragment } from '@/components/item_types/item_type'
import { graphql } from '@/gql'
import { useQuery } from '@apollo/client/react'
import { Slimline as Error } from '@/components/error'
import { LoadingSkeleton } from '@/components/base/loading-skeleton'
import { Delete } from '@/components/item_types/delete'
import { useState } from 'react'
import { Button } from '@/components/base/button'

const ItemTypeQuery = graphql(`
  query ItemType($id: ID!) {
    itemTypes(filters: { idEq: $id }) {
      nodes {
        id
        name
        ...ItemTypeDetail
      }
    }
  }
`)

export const Show = () => {
  const { id } = useParams() as { id: string }

  const { data, loading, error } = useQuery(ItemTypeQuery, { variables: { id } })

  const [showDelete, setShowDelete] = useState(false)

  if (loading) return <LoadingSkeleton table title />

  return (<div className="flex flex-col gap-3 grow">
    { error && <Error error={ error } /> }
    { data && <>
      <div className="flex flex-row justify-between items-center">
        <Heading level={ 1 } size="3xl">{ data.itemTypes.nodes[0].name }</Heading>
        <div className="flex flex-row gap-3 items-center">
          <Button color="purple" href="connector_families">Connectors</Button>
          <Button color="red" onClick={ () => setShowDelete(true) }>Delete</Button>
        </div>
      </div>
      <ItemType id={ id } />
      <Delete id={ id } open={ showDelete } setOpen={ setShowDelete } />
    </> }
  </div>)
}
